// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body {\n  margin: 0;\n  padding: 0;\n  font-family: sans-serif;\n}\n\n#page-container {\n  position: relative;\n  min-height: 100vh;\n}\n\n#content-wrap {\n  padding-bottom: 2.5rem;\n}\n\n#footer {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  height: 8rem;\n}\n", ""]);
// Exports
module.exports = exports;
